// TO's settings: the modal's sections (SettingsModal) and the sidebar's
// Settings link (KoobLayout), from this one list.

const NOTIFICATIONS = '/user/notification-preferences';

/** Paths the settings modal shows (App.js renders them over the last page). */
const SETTINGS_PATHS = [
  NOTIFICATIONS,
  '/audit-log',
  '/travel-diary-content-library',
  '/travel-diary-settings',
];

export const isSettingsPath = pathname =>
  SETTINGS_PATHS.some(
    path => pathname === path || pathname.startsWith(`${path}/`),
  );

/** The modal's sections: the user's own, then the organization's (empty
 * groups left out). */
export const settingsSections = (t, isAllowedTo, currentUserRole) =>
  [
    {
      label: t('settingsModal.user'),
      links: [
        {
          to: NOTIFICATIONS,
          icon: 'far fa-bell',
          label: t('settingsModal.notifications'),
          activeMatch: [NOTIFICATIONS],
        },
      ],
    },
    {
      label: t('settingsModal.organization'),
      links: [
        isAllowedTo('readAuditLog') && {
          to: '/audit-log',
          icon: 'far fa-clock-rotate-left',
          label: t('auditLog'),
          activeMatch: ['/audit-log'],
        },
        isAllowedTo('readTravelDiaryContent') && {
          to: '/travel-diary-content-library',
          icon: 'far fa-book-open',
          label: t('travelDiaryContent'),
          activeMatch: ['/travel-diary-content-library'],
        },
        currentUserRole === 'to_admin' && {
          to: '/travel-diary-settings',
          icon: 'far fa-palette',
          label: t('travelDiaryTheme'),
          activeMatch: ['/travel-diary-settings'],
        },
      ].filter(Boolean),
    },
  ].filter(group => group.links.length);
